import Head from 'next/head';

interface CustomLdJsonProps {
    customLdJson: object | undefined | null;
}

const CustomLdJson = ({ customLdJson }: CustomLdJsonProps) => {
    if (process.env.NEXT_PUBLIC_ENABLE_CUSTOM_LDJSON !== 'on') {
        return null;
    }

    return customLdJson ? (
        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(customLdJson) }} />
        </Head>
    ) : null;
};

export default CustomLdJson;
